
import MdContent from 'components/md-content-v2'

export default {
  components: {MdContent},
  props: {
    item: {type: Object, required: true},
    current: {type: Boolean, default: false},
    initialOpen: {type: Boolean, default: false}
  },
  emits: ['expanded'],
  data() {
    return {
      open: this.initialOpen
    }
  },
  methods: {
    toggle() {
      if (!this.item.description) return
      this.open = !this.open
    }
  }
}
